(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScopeDeleteDialogController', ScopeDeleteDialogController);

    ScopeDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'IntegrationScope'];

    function ScopeDeleteDialogController($uibModalInstance, entity, IntegrationScope) {
        var vm = this;
        vm.scope = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (scope) {
            IntegrationScope.delete({scope: scope},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
